export default __webpack_public_path__ + "static/media/bg1.95a49c59.png";